<template>
    <div class="card background--white">
        <div
            v-if="hasTitle"
            :class="[
                'card__title card--padding capitalize',
                {
                    'card__title--margin': addMargins,
                    'background--blue color--white': !isAuthCard,
                    'card__title--center': isAuthCard
                }
            ]"
        >
            <slot name="card__title" />
        </div>
        <div
            :class="[
                'card__body position--relative',
                { 'card--padding': addMargins }
            ]"
        >
            <slot name="card__body" />
        </div>
    </div>
</template>

<script>
// packages
import { computed } from '@vue/composition-api';

export default {
    props: {
        addMargins: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'default'
        }
    },
    setup ( props, { slots }) {
        // validação se o card tem titulo.
        const hasTitle = computed( () => slots.card__title );

        // valida se é uma card de autenticação.
        const isAuthCard = computed( () => props.type === 'authentication' );

        return { hasTitle, isAuthCard };
    }
};
</script>

<style lang="scss">
    .card {
        width: 100%;
        padding: 0 0 25px;
        @include rounded-corner( 5px );
        &--authentication {
            @include rounded-corner( 10px );
            @include box-shadow( 0 3px 6px $color-shadow-default );
        }
        &--identification {
            grid-column: 1 / -1;
        }
        &--padding {
            padding: $card-spacing;
        }
        &__title {
            @include typography-specs( 16px, 26px, 700 );
            &--margin {
                margin-bottom: $card-space-between-header-body;
            }
            &--center {
                text-align: center;
            }
        }

    }
</style>